module.exports = {
  BARON: { api: 'Baron', human: 'Baron' },
  BARONIN: { api: 'Baronin', human: 'Baronin' },
  FREIFRAU: { api: 'Freifrau', human: 'Freifrau' },
  FREIHERR: { api: 'Freiherr', human: 'Freiherr' },
  FÜRST: { api: 'Fürst', human: 'Fürst' },
  FÜRSTIN: { api: 'Fürstin', human: 'Fürstin' },
  GRAF: { api: 'Graf', human: 'Graf' }
}
